import React from "react";
import { Box } from "@mui/material";

/**
 * AuthShell
 * Full-bleed split-panel auth layout that fills the whole page: the branded
 * `brand` panel sits on the left (hidden on small screens) and the form
 * (`children`) sits on the right.
 */
export default function AuthShell({ brand, children, maxFormWidth = 440 }) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Brand side (left) */}
      <Box
        sx={{
          flex: { md: "1 1 50%" },
          display: { xs: "none", md: "flex" },
        }}
      >
        {brand}
      </Box>

      {/* Form side (right) */}
      <Box
        sx={{
          flex: { md: "1 1 50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fff",
          px: { xs: 3, sm: 6, md: 8 },
          py: { xs: 6, md: 6 },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: maxFormWidth }}>{children}</Box>
      </Box>
    </Box>
  );
}
